import family from "../images/family.jpg"
import family1 from "../images/family1.jpg"
import family2 from "../images/family2.jpg"
import family3 from "../images/family3.jpg"
import family4 from "../images/family4.jpg"
import family5 from "../images/family5.jpg"




function ScrollGallery() {
    
  const images = [
   family,
   family1,
   family2,
   family3,
   family4,
   family5
  ];

  return (
    <div style={{ overflowX: "auto", display: "flex", gap: "10px" }}>
      {images.map((img, index) => (
        <img
        className="family-scroll"
          key={index}
          src={img}
          alt="gallery"
          style={{ width: "250px", height: "180px", objectFit: "cover" }}
        />
      ))}
    </div>
  );
}

export default ScrollGallery;